var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import Button from '@mui/material/Button';
import CustomLoader from './CustomLoader';
var classes = {
    buttonRoot: function (theme) { return ({
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        '&:hover.Mui-disabled, & .Mui-disabled': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.background.default,
            opacity: 0.5,
        },
    }); },
    loaderRoot: function (theme) { return ({
        color: theme.palette.background.default,
        padding: theme.spacing(0, 0.65),
    }); },
};
export default function CustomButton(_a) {
    var buttonText = _a.buttonText, _b = _a.buttonLoading, buttonLoading = _b === void 0 ? false : _b, _c = _a.loaderAttributes, loaderAttributes = _c === void 0 ? {
        size: 20,
        thickness: 5,
    } : _c, _d = _a.buttonClassSX, buttonClassSX = _d === void 0 ? {} : _d, other = __rest(_a, ["buttonText", "buttonLoading", "loaderAttributes", "buttonClassSX"]);
    return (React.createElement(Button, __assign({ disableRipple: true, disableFocusRipple: true, sx: __spreadArray([classes.buttonRoot], (Array.isArray(buttonClassSX) ? buttonClassSX : [buttonClassSX]), true) }, other),
        buttonLoading && (React.createElement(CustomLoader, { loaderSx: classes.loaderRoot, loaderAttributes: loaderAttributes })),
        buttonText));
}
